import React from 'react';
import styled from 'styled-components';
import Section from './ui/Section';
import Container from './ui/Container';
import SectionHeading from './ui/SectionHeading';
import Reveal from './ui/Reveal';
import ProjectCard from './ProjectCard';
import { getProject } from '../data/projects';

const Stack = styled.div`
  display: grid;
  gap: 1.5rem;
`;

const Pair = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const WorkShowcase: React.FC = () => (
  <Section aria-labelledby="work-title">
    <Container>
      <SectionHeading
        id="work-title"
        eyebrow="Work"
        title="Selected work"
        description="Three recent projects: a production caregiving platform, a local service business site, and a bilingual pet-care brand."
      />
      <Stack>
        <Reveal>
          <ProjectCard project={getProject('likefamily')} layout="feature" />
        </Reveal>
        <Pair>
          <Reveal>
            <ProjectCard project={getProject('rbcarcare')} />
          </Reveal>
          <Reveal delay={0.06}>
            <ProjectCard project={getProject('raicesypatitas')} />
          </Reveal>
        </Pair>
      </Stack>
    </Container>
  </Section>
);

export default WorkShowcase;
